import {
  BaseModel,
  TargetableModel,
} from '@cotera/client/v0/actions/framework';
import { ResourceType } from '@cotera/api';

export { ResourceType };
export type ResourceSelection = {
  resourceType: ResourceType;
  resourceId: string;
  name: string;
};

/**
 * Model used on list pages (agents, chats, triggers, folder contents) to represent
 * the currently focused/selected resource(s). When the user opens the
 * ellipsis menu on a row, we set this model's selections and target it
 * so that actions (Share, Archive, Move to folder) can act on the selection.
 * Supports multiple mixed resource types for future list views.
 */
export class ResourceSelectionModel
  extends BaseModel
  implements TargetableModel
{
  private _isTargeted = false;
  private _selections: ResourceSelection[] = [];

  constructor() {
    super('resource-selection');
  }

  get selections(): ResourceSelection[] {
    return this._selections.map((selection) => ({ ...selection }));
  }

  setSelections(selections: ResourceSelection[]): void {
    const seen = new Set<string>();
    this._selections = selections.filter((selection) => {
      const key = `${selection.resourceType}:${selection.resourceId}`;
      if (seen.has(key) === true) {
        return false;
      }
      seen.add(key);
      return true;
    });
  }

  getResourceIdsForType(resourceType: ResourceType): string[] {
    return this._selections
      .filter((selection) => selection.resourceType === resourceType)
      .map((selection) => selection.resourceId);
  }

  getResourceForType(
    resourceType: ResourceType
  ): ResourceSelection | undefined {
    return this._selections.find(
      (selection) => selection.resourceType === resourceType
    );
  }

  clearSelections(): void {
    this._selections = [];
  }

  get isTargeted(): boolean {
    return this._isTargeted;
  }

  target(): void {
    this._isTargeted = true;
  }

  markAsNotTargeted(): void {
    this._isTargeted = false;
  }
}
